<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Tasks</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Monitor running and completed MCP tasks
        </p>
      </div>
      <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
        <span>{{ store.runningTasks.length }} running</span>
        <span>{{ store.completedTasks.length }} completed</span>
      </div>
    </div>

    <!-- eslint-disable-next-line asab-design-system/no-raw-button-card-markup -- dashed empty-state box, not a Card (no dashed/empty variant exists yet) -->
    <div
      v-if="store.tasks.length === 0"
      class="text-center py-8 bg-gray-50 dark:bg-gray-800/50 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-700"
    >
      <p class="text-sm text-gray-500 dark:text-gray-400">No tasks recorded</p>
    </div>

    <div v-else class="space-y-2">
      <div
        v-for="task in store.tasks"
        :key="task.id"
        class="border border-gray-200 dark:border-gray-700 rounded-lg p-3"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span :class="statusBadgeClass(task.status)">
              {{ task.status }}
            </span>
            <span class="text-sm text-gray-900 dark:text-white font-mono">
              {{ task.id.slice(0, 8) }}
            </span>
          </div>
          <span class="text-xs text-gray-500 dark:text-gray-400">
            {{ formatDate(task.created_at) }}
          </span>
        </div>

        <p v-if="task.message" class="mt-1 text-xs text-gray-600 dark:text-gray-400">
          {{ task.message }}
        </p>

        <div
          v-if="task.progress != null && task.total != null && task.total > 0"
          class="mt-2"
        >
          <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5">
            <div
              class="bg-blue-600 h-1.5 rounded-full transition-all"
              :style="{ width: `${Math.round((task.progress / task.total) * 100)}%` }"
            />
          </div>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            {{ task.progress }}/{{ task.total }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMcpProtocolStore } from '@/stores/mcpProtocol';

  const store = useMcpProtocolStore();

  const statusBadgeClass = (status: string): string => {
    const base = 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium';
    switch (status) {
      case 'working':
        return `${base} bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300`;
      case 'completed':
        return `${base} bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300`;
      case 'failed':
        return `${base} bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300`;
      case 'cancelled':
        return `${base} bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300`;
      default:
        return `${base} bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300`;
    }
  };

  const formatDate = (iso: string): string => {
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  };
</script>
